import { FormikProps } from 'formik';
import React from 'react';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { PhoneField } from '../../../../../global/components/form-element/phone-input';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { ContactInformationFields } from '../../../../account-info/models/form-models';

interface Props {
    formProps: FormikProps<any>;    
    labelSettings,
    contactInformationFields?: ContactInformationFields,
    orgType?: string,
}

export function ContactInformation(props: Props) {
    const { formProps, labelSettings, contactInformationFields, orgType } = props;
    const isEmailRequired = orgType !== 'Trusts and Estates';
    
    return (
        <>
            <FormGroup>
                <PhoneField
                    label={labelSettings?.officePhone}
                    countryFieldName={contactInformationFields?.business_phone_country_code || 'business_phone_country_code' }
                    phoneFieldName= { contactInformationFields?.business_phone_formatted || 'business_phone_formatted' }
                    extFieldName= { contactInformationFields?.business_phone_extension || 'business_phone_extension' }
                    ext
                    extLabel={labelSettings?.extensionLabel}
                    formProps={formProps}
                    required
                />
                <PhoneField
                    label={labelSettings?.faxPhone}
                    countryFieldName= { contactInformationFields?.fax_phone_country_code || 'fax_phone_country_code' }
                    phoneFieldName= { contactInformationFields?.fax_phone_formatted || 'fax_phone_formatted' }
                    extFieldName= { contactInformationFields?.fax_phone_extension || 'fax_phone_extension' }
                    ext={false}
                    formProps={formProps}
                />
                <FormField
                    name= { contactInformationFields?.business_email_address || 'business_email_address' }
                    label={labelSettings?.institutionEmailAddress}
                    component='input'
                    errors={formProps.errors}
                    touched={formProps.touched}
                    required={isEmailRequired}
                />
                <FormField
                    name= { contactInformationFields?.website_url || 'website_url' }
                    label={labelSettings?.website}
                    component='input'
                    errors={formProps.errors}
                    touched={formProps.touched}
                />
            </FormGroup>
        </>
    );
}

ContactInformation.defaultProps = {
    contactInformationFields: null,
    orgType: null,
};